<template lang="pug">
  #ProgramDetails
    WtTitle(h3) Program Details
    BField(
      :type="{ 'is-danger': errors.has('program-name') }"
      :message="errors.first('program-name')"
    )
      WtLabel(
        slot="label"
        text="Name Your Program"
        label-for="program-name"
        required
        subLabel="This can be your company name, or something unique!"
      )
      BInput(
        placeholder="Program name"
        v-model="programName"
        name="program-name"
        v-validate="'required'"
      )
    BField(
      :type="{ 'is-danger': errors.has('program-url') }"
      :message="errors.first('program-url')"
    )
      UniquenessCheck(
        is-url
        label="Create Program URL"
        subLabel="You'll use this link to login to your program again."
        entity="programUrl"
        placeholder="Program URL"
        v-model="programUrl"
        @validName="onValidProgramUrl"
        name="program-url"
        v-validate="'required'"
      )
    BField(
      :type="{ 'is-danger': errors.has('seats') }"
      :message="errors.first('seats')"
      v-if="!isManagedProgram"
    )
      WtLabel(
        slot="label"
        text="Number of Participants"
        label-for="seats"
        required
        subLabel="You can add more at any time."
      )
      BInput(
        placeholder="50"
        :min="1"
        type="number"
        v-model="seats"
        name="seats"
        v-validate.disable="'required'"
      )
    BField(
      :type="{ 'is-danger': errors.has('totalEligibleEmployees') }"
      :message="errors.first('totalEligibleEmployees')"
      v-if="isManagedProgram"
    )
      WtLabel(
        slot="label"
        text="Number Eligible"
        label-for="totalEligibleEmployees"
        subLabel="How many people are eligible to register for your program? This can be an estimate."
      )
      BInput(
        placeholder="500"
        :min="1"
        type="number"
        v-model="totalEligibleEmployees"
        name="totalEligibleEmployees"
        v-validate.disable=""
      )

</template>

<script>
import WtButton from "@@/WtButton/WtButton";
import WtLabel from "@@/WtLabel/WtLabel";
import WtTitle from "@@/WtTitle/WtTitle";
import UniquenessCheck from "@@/WtUniquenessCheckInput/WtUniquenessCheckInput";

export default {
  name: "ProgramDetails",

  components: { WtButton, WtLabel, WtTitle, UniquenessCheck },

  data() {
    return {
      totalEligibleEmployees: "",
      seats: 1,
      seatsTooltip: ``,
      programName: null,
      programNameTooltip: ``,
      programUrl: null,
      isProgramUrlValid: false,
      programUrlTooltip: ``
    };
  },

  computed: {
    formData() {
      return {
        totalEligibleEmployees: this.totalEligibleEmployees,
        seats: this.seats,
        programName: this.programName,
        programUrl: this.programUrl
      };
    },

    isAllValid() {
      return (
        !this.errors.any() &&
        this.isProgramUrlValid &&
        this.seats > 0 &&
        !this._.isEmpty(this.programName)
      );
    },

    isManagedProgram() {
      return this.$route.path.includes("managed");
    }
  },

  watch: {
    isAllValid() {
      this.$emit("newProgramDetails", {
        isValid: this.isAllValid,
        formData: this.formData
      });
    },

    seats() {
      this.$emit("newProgramDetails", {
        isValid: this.isAllValid,
        formData: this.formData
      });
    }
  },

  methods: {
    onValidProgramUrl($event) {
      this.isProgramUrlValid = $event;
      this.$emit("newProgramDetails", {
        isValid: this.isAllValid,
        formData: this.formData
      });
    }
  }
};
</script>

<style scoped lang="sass">
#ProgramDetails
</style>
